import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-789dbdc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-full items-center justify-center flex-col" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "px-1 py-1" }
const _hoisted_4 = {
  disabled: "",
  class: "group flex w-full items-center rounded-md px-2 py-2 text-sm"
}
const _hoisted_5 = { class: "px-1 py-1" }

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { UserCircleIcon } from '@heroicons/vue/20/solid'
import { ref, toRefs } from 'vue';
import { signOut } from 'firebase/auth'
import { useFirebaseAuth } from 'vuefire';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileIconComponent',
  props: {
    user: {}
  },
  setup(__props: any) {

const auth = useFirebaseAuth()

const name = ref('')
const image = ref('')
const isLightMode = ref(true); // Toggle this to switch between light and dark mode

const props = __props

let { user } = toRefs(props)

if (user) {
  name.value = user.value.displayName || user.value.email || user.value.phoneNumber
  image.value = user.value.photoURL
}

const logout = async () => {
  await signOut(auth);
  window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(isLightMode.value ? 'z-[9999] light-mode' : 'z-[9999] dark-mode')
  }, [
    _createVNode(_unref(Menu), {
      as: "div",
      class: "relative block justify-center items-center h-full text-left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(MenuButton), { class: "inline-flex flex-col w-full h-full justify-center items-center" }, {
            default: _withCtx(() => [
              (image.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: name.value,
                    class: "rounded-full w-8 h-8 object-cover",
                    src: image.value
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createBlock(_unref(UserCircleIcon), {
                    key: 1,
                    class: "rounded-full w-8 h-8 text-gray-500"
                  }))
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-in",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuItems), {
              class: _normalizeClass([
            'absolute right-0 mt-2 w-56 origin-top-right divide-y rounded-md shadow-lg ring-1 focus:outline-none z-[9999]',
            isLightMode.value ? 'bg-white divide-gray-200 ring-black/5' : 'bg-brand-card divide-gray-100 ring-black/5'
          ])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", _hoisted_4, _toDisplayString(name.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("button", {
                        onClick: logout,
                        class: _normalizeClass([
                  active ? (isLightMode.value ? 'bg-red-500 text-white' : 'bg-red-500 text-white') : '',
                  'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                  isLightMode.value ? 'text-black' : 'text-white'
                ])
                      }, " Logout ", 2)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})